"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPdf = void 0;
var pdfjs_dist_1 = require("pdfjs-dist");
setWorkerSource();
var defaultOptions = {
    addLink: false
};
var PDF_SRC_ATTR = 'data-pdf-src';
var PDF_PAGE_ATTR = 'data-pdf-page';
var PDF_SCALE_ATTR = 'data-pdf-scale';
function createPdf(canvas, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var pageNumber, src, pdfDoc, page, viewport, ctx, outputScale, transform, a, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    pageNumber = parseInt((_a = canvas.getAttribute(PDF_PAGE_ATTR)) !== null && _a !== void 0 ? _a : '1');
                    if (!pageNumber) {
                        console.warn("attribute ".concat(PDF_PAGE_ATTR, " is not an integral number on element with ").concat(PDF_SRC_ATTR, "=").concat(canvas.getAttribute(PDF_SRC_ATTR)));
                        return [2 /*return*/];
                    }
                    src = canvas.getAttribute(PDF_SRC_ATTR);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, (0, pdfjs_dist_1.getDocument)(src).promise];
                case 2:
                    pdfDoc = _c.sent();
                    return [4 /*yield*/, pdfDoc.getPage(pageNumber)];
                case 3:
                    page = _c.sent();
                    viewport = page.getViewport({ scale: parseFloat((_b = canvas.getAttribute(PDF_SCALE_ATTR)) !== null && _b !== void 0 ? _b : '1.0') });
                    ctx = canvas.getContext("2d");
                    outputScale = window.devicePixelRatio || 1;
                    canvas.width = Math.floor(viewport.width * outputScale);
                    canvas.height = Math.floor(viewport.height * outputScale);
                    canvas.style.width = Math.floor(viewport.width) + "px";
                    canvas.style.height = Math.floor(viewport.height) + "px";
                    transform = outputScale !== 1
                        ? [outputScale, 0, 0, outputScale, 0, 0]
                        : undefined;
                    return [4 /*yield*/, page.render({
                            canvasContext: ctx !== null && ctx !== void 0 ? ctx : {},
                            transform: transform,
                            viewport: viewport,
                        }).promise];
                case 4:
                    _c.sent();
                    if (options.addLink) {
                        a = document.createElement('a');
                        a.href = src;
                        if (pageNumber != 1) {
                            a.href += "#page=".concat(pageNumber);
                        }
                        canvas.replaceWith(a);
                        a.append(canvas);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _c.sent();
                    console.error("failed to render pdf ".concat(src, ": ").concat(err_1));
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.createPdf = createPdf;
function setWorkerSource() {
    if (document.currentScript instanceof HTMLScriptElement) {
        var src = document.currentScript.src.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
        pdfjs_dist_1.GlobalWorkerOptions.workerSrc = src;
    }
}
function init(deck) {
    var _this = this;
    var _a;
    var options = Object.assign(defaultOptions, (_a = deck.getConfig().pdf) !== null && _a !== void 0 ? _a : {});
    var duringSlideChange = true;
    deck.on('ready', function (_) { return __awaiter(_this, void 0, void 0, function () {
        var pdfCanvases, _i, pdfCanvases_1, canvas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pdfCanvases = Array.from(deck.getSlidesElement().querySelectorAll('canvas')).filter(function (_) { return _.hasAttribute(PDF_SRC_ATTR); });
                    if (!pdfCanvases) {
                        console.warn("no elements with attribute ".concat(PDF_SRC_ATTR, " found"));
                        return [2 /*return*/];
                    }
                    _i = 0, pdfCanvases_1 = pdfCanvases;
                    _a.label = 1;
                case 1:
                    if (!(_i < pdfCanvases_1.length)) return [3 /*break*/, 4];
                    canvas = pdfCanvases_1[_i];
                    return [4 /*yield*/, createPdf(canvas, options)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    deck.layout();
                    return [2 /*return*/];
            }
        });
    }); });
}
exports.default = (function () {
    return {
        id: 'reveal-pdf',
        init: init
    };
});
